// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateRangePicker_rangePicker__GCJfO {
    width: 100%;
}

.DateRangePicker_dateText__0d7-s {
    margin: 5px 0;
    min-height: 22px;
}

.DateRangePicker_dayPicker__WTfKm {
    position: relative;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/DateRangePicker/DateRangePicker.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".rangePicker {\n    width: 100%;\n}\n\n.dateText {\n    margin: 5px 0;\n    min-height: 22px;\n}\n\n.dayPicker {\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rangePicker": `DateRangePicker_rangePicker__GCJfO`,
	"dateText": `DateRangePicker_dateText__0d7-s`,
	"dayPicker": `DateRangePicker_dayPicker__WTfKm`
};
export default ___CSS_LOADER_EXPORT___;
